/**
 * Author: BaiJiFeiLong@gmail.com
 * Datetime: 2017/6/24 下午12:13
 */

import React from 'react';
import Waiting from './Waiting';
import Error from './Error';
import { Button, Col, ControlLabel, Form, FormGroup, Tab, Tabs } from 'react-bootstrap';
import ElementEdit from './ElementEdit';
import * as api from '../api';
import { configFields } from '../helpers/ConfigsHelper';

export default class ConfigsFront extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            configs: null,
            loading: true,
            error: null,
            tabs: {
                版本更新: [
                    'androidVersion',
                    'androidReviewVersion',
                    'iosVersion',
                    'iosReviewVersion',
                    'isAuditMode',
                    'harmonyVersion',
                    'harmonyReviewVersion',
                    'androidNewVersion',
                    'iosNewVersion',
                    'harmonyNewVersion',
                    'isAndroidUpdate',
                    'isIosUpdate',
                    'isHarmonyUpdate',
                    'androidUpdateDescription',
                    'iosUpdateDescription',
                    'harmonyUpdateDescription',
                    'androidHotUpdateVersion',
                    'androidVersionOpenUpdate',
                    'harmonyHotUpdateVersion',
                    'harmonyVersionOpenUpdate',
                    'iosHotUpdateVersion',
                    'iosVersionOpenUpdate',
                    'iosForceUpdate',
                    'androidForceUpdate',
                    'harmonyForceUpdate',
                    'isUseHttpDns',
                    'httpReqFailIsToast',
                    'privacyPolicy',
                    'serviceAgreement',
                    'updateNotificationTxt'
                ],
                bangtabs版本更新: [
                    'androidVersionBangtabs',
                    'androidReviewVersionBangtabs',
                    'iosVersionBangtabs',
                    'iosReviewVersionBangtabs',
                    'androidNewVersionBangtabs',
                    'iosNewVersionBangtabs',
                    'isAndroidUpdateBangtabs',
                    'isIosUpdateBangtabs',
                    'androidUpdateDescriptionBangtabs',
                    'iosUpdateDescriptionBangtabs',
                    'androidHotUpdateVersionBangtabs',
                    'androidVersionOpenUpdateBangtabs',
                    'iosHotUpdateVersionBangtabs',
                    'iosVersionOpenUpdateBangtabs',
                    'iosForceUpdateBangtabs',
                    'androidForceUpdateBangtabs'
                ]
            },
            currentTabIndex: 1
        };
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
    }

    componentDidMount() {
        api.getConfigs()
            .then((json) =>
                this.setState({
                    loading: false,
                    error: null,
                    configs: json.data
                })
            )
            .catch((error) =>
                this.setState({
                    loading: false,
                    error
                })
            );
    }

    onChange(key, value) {
        const { configs } = this.state;
        configs[key] = value;
        this.forceUpdate();
    }
    handleSelect(key) {
        this.setState({
            currentTabIndex: key
        });
    }
    onSubmit(e) {
        e.preventDefault();
        const { configs, tabs, currentTabIndex } = this.state;
        this.setState({ loading: true });
        const key = Object.keys(tabs)[currentTabIndex - 1];
        const data = {};
        for (let i in tabs[key]) {
            data[tabs[key][i]] = configs[tabs[key][i]];
        }
        api.updateConfigs(data)
            .then((json) => {
                this.setState({
                    loading: false,
                    configs: json.data
                });
            })
            .catch((error) => {
                this.setState({
                    loading: false,
                    error
                });
            });
    }

    render() {
        const { configs, loading, error, tabs, currentTabIndex } = this.state;

        return (
            <div style={{ marginTop: 10 }}>
                <Waiting isVisible={loading} />
                <Error error={error} onOk={() => this.setState({ error: null })} />
                <Form horizontal>
                    <Tabs activeKey={currentTabIndex} id="tabs" onSelect={this.handleSelect}>
                        {Object.entries(tabs).map(([tab, keys], index) => {
                            return (
                                <Tab
                                    key={index}
                                    eventKey={index + 1}
                                    title={tab}
                                    style={{ paddingTop: 15 }}
                                >
                                    {configs
                                        ? Object.entries(configFields)
                                              .filter(([key, _]) => keys.includes(key))
                                              .map(([key, field], index) => {
                                                  const value = configs[key];
                                                  return (
                                                      <FormGroup key={index}>
                                                          <Col componentClass={ControlLabel} sm={2}>
                                                              {field.title}
                                                          </Col>
                                                          <Col sm={10}>
                                                              <ElementEdit
                                                                  type={field.type}
                                                                  value={value}
                                                                  onValueChange={(value) =>
                                                                      this.onChange(key, value)
                                                                  }
                                                              />
                                                          </Col>
                                                      </FormGroup>
                                                  );
                                              })
                                        : null}
                                </Tab>
                            );
                        })}
                    </Tabs>
                    <FormGroup>
                        <Col sm={10} smOffset={2}>
                            <Button bsStyle="success" onClick={this.onSubmit}>
                                提交
                            </Button>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// src/components/ConfigsFront.js